import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, DatePicker, Icon, notification, Divider, Button } from "antd";
import axios from "axios";
import moment from "moment";
import SectionCard from "../../components/SectionCard";
import SectionDivider from "../../components/SectionDivider";

const { TextArea } = Input;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({ message, description });
};

const parseObject = (value, fallback = {}) => {
    if (!value) return fallback;
    if (typeof value === "object" && !Array.isArray(value)) return value;
    try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : fallback;
    } catch {
        return fallback;
    }
};

const parseArray = (value, fallback = []) => {
    if (!value) return fallback;
    if (Array.isArray(value)) return value;
    try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : fallback;
    } catch {
        return fallback;
    }
};

const ListaDinamica = ({ value = [], onChange, placeholder = "Adicionar item..." }) => {
    const handleChange = (index, newValue) => {
        const nova = [...value];
        nova[index] = newValue;
        onChange && onChange(nova);
    };

    const handleRemove = index => {
        const nova = value.filter((_, i) => i !== index);
        onChange && onChange(nova.length ? nova : [""]);
    };

    const lista = value.length ? value : [""];

    return (
        <div>
            {lista.map((item, index) => (
                <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: 6, gap: 8 }}>
                    <span style={{ minWidth: 20, color: "#888", fontSize: 12 }}>{index + 1}.</span>
                    <Input value={item} onChange={e => handleChange(index, e.target.value)} placeholder={placeholder} style={{ flex: 1 }} />
                    {lista.length > 1 && (
                        <Button
                            type="danger"
                            size="small"
                            ghost
                            icon="minus"
                            onClick={() => handleRemove(index)}
                            style={{ flexShrink: 0 }}
                        />
                    )}
                </div>
            ))}
        </div>
    );
};

const DrawerPlanoPAEE = ({ id, visible, atualizarListagem, onClose, form }) => {
    const estadoInicial = {
        apresentacao: {
            ano_letivo: "",
            aluno: "",
            data_nascimento: null,
            serie_turma: "",
            professor_srm: "",
            pedagogo_coordenador: "",
            responsaveis_legais: ""
        },
        descricao_aluno: {
            caracteristicas: "",
            diagnostico: ""
        },
        objetivos_educacionais: {
            metas_aprendizagem: [""],
            aspectos_sociais: [""]
        },
        plano_acao: {
            estrategias_pedagogicas: "",
            materiais_recursos: "",
            atividades_complementares: [""]
        },
        periodo_duracao: {
            data_inicio: null,
            data_termino: null,
            data_revisao: null
        },
        resultados: {
            indicadores_aprendizagem: [""],
            avaliacao_progresso: ""
        },
        observacoes_complementares: {
            informacoes_adicionais: "",
            sugestoes_ajustes: ""
        }
    };

    const [registo, setRegisto] = useState(estadoInicial);
    const [isLoading, setIsLoading] = useState(false);

    const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = form;

    const adicionarItemLista = fieldName => {
        const atual = getFieldValue(fieldName) || [""];
        setFieldsValue({ [fieldName]: [...atual, ""] });
    };

    const handleSubmit = e => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (!err) {
                if (id) {
                    alterarPlano(values);
                } else {
                    adicionarPlano(values);
                }
            }
        });
    };

    const carregarDetalhe = id => {
        setIsLoading(true);

        axios({ method: "get", url: "/api/plano-atendimento/carregar-plano-atendimento", params: { id } })
            .then(response => {
                const data = response.data;

                const apresentacao = parseObject(data.apresentacao, estadoInicial.apresentacao);
                const descricao_aluno = parseObject(data.descricao_aluno, estadoInicial.descricao_aluno);
                const objetivos_educacionais = parseObject(data.objetivos_educacionais, estadoInicial.objetivos_educacionais);
                const plano_acao = parseObject(data.plano_acao, estadoInicial.plano_acao);
                const periodo_duracao = parseObject(data.periodo_duracao, estadoInicial.periodo_duracao);
                const resultados = parseObject(data.resultados, estadoInicial.resultados);
                const observacoes_complementares = parseObject(data.observacoes_complementares, estadoInicial.observacoes_complementares);

                const dados = {
                    apresentacao: {
                        ano_letivo: apresentacao.ano_letivo || "",
                        aluno: apresentacao.aluno || "",
                        data_nascimento: apresentacao.data_nascimento ? moment(apresentacao.data_nascimento) : null,
                        serie_turma: apresentacao.serie_turma || "",
                        professor_srm: apresentacao.professor_srm || "",
                        pedagogo_coordenador: apresentacao.pedagogo_coordenador || "",
                        responsaveis_legais: apresentacao.responsaveis_legais || ""
                    },
                    descricao_aluno,
                    objetivos_educacionais: {
                        metas_aprendizagem: parseArray(objetivos_educacionais.metas_aprendizagem, [""]),
                        aspectos_sociais: parseArray(objetivos_educacionais.aspectos_sociais, [""])
                    },
                    plano_acao: {
                        ...plano_acao,
                        atividades_complementares: parseArray(plano_acao.atividades_complementares, [""])
                    },
                    periodo_duracao: {
                        data_inicio: periodo_duracao.data_inicio ? moment(periodo_duracao.data_inicio) : null,
                        data_termino: periodo_duracao.data_termino ? moment(periodo_duracao.data_termino) : null,
                        data_revisao: periodo_duracao.data_revisao ? moment(periodo_duracao.data_revisao) : null
                    },
                    resultados: {
                        ...resultados,
                        indicadores_aprendizagem: parseArray(resultados.indicadores_aprendizagem, [""])
                    },
                    observacoes_complementares
                };

                setRegisto(dados);

                setFieldsValue({
                    apresentacao_ano_letivo: dados.apresentacao.ano_letivo || "",
                    apresentacao_aluno: dados.apresentacao.aluno || "",
                    apresentacao_data_nascimento: dados.apresentacao.data_nascimento,
                    apresentacao_serie_turma: dados.apresentacao.serie_turma || "",
                    apresentacao_professor_srm: dados.apresentacao.professor_srm || "",
                    apresentacao_pedagogo_coordenador: dados.apresentacao.pedagogo_coordenador || "",
                    apresentacao_responsaveis_legais: dados.apresentacao.responsaveis_legais || "",

                    descricao_caracteristicas: dados.descricao_aluno.caracteristicas || "",
                    descricao_diagnostico: dados.descricao_aluno.diagnostico || "",

                    objetivos_metas_aprendizagem: dados.objetivos_educacionais.metas_aprendizagem,
                    objetivos_aspectos_sociais: dados.objetivos_educacionais.aspectos_sociais,

                    plano_estrategias_pedagogicas: dados.plano_acao.estrategias_pedagogicas || "",
                    plano_materiais_recursos: dados.plano_acao.materiais_recursos || "",
                    plano_atividades_complementares: dados.plano_acao.atividades_complementares,

                    periodo_data_inicio: dados.periodo_duracao.data_inicio,
                    periodo_data_termino: dados.periodo_duracao.data_termino,
                    periodo_data_revisao: dados.periodo_duracao.data_revisao,

                    resultados_indicadores: dados.resultados.indicadores_aprendizagem,
                    resultados_avaliacao_progresso: dados.resultados.avaliacao_progresso || "",

                    obs_informacoes_adicionais: dados.observacoes_complementares.informacoes_adicionais || "",
                    obs_sugestoes_ajustes: dados.observacoes_complementares.sugestoes_ajustes || ""
                });
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao carregar detalhe.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const montarPayload = values => ({
        id_disciplina: localStorage.getItem("codigo_curso"),
        tipo: "paee",

        apresentacao: JSON.stringify({
            ano_letivo: values.apresentacao_ano_letivo || "",
            aluno: values.apresentacao_aluno || "",
            data_nascimento: values.apresentacao_data_nascimento ? values.apresentacao_data_nascimento.format("YYYY-MM-DD") : null,
            serie_turma: values.apresentacao_serie_turma || "",
            professor_srm: values.apresentacao_professor_srm || "",
            pedagogo_coordenador: values.apresentacao_pedagogo_coordenador || "",
            responsaveis_legais: values.apresentacao_responsaveis_legais || ""
        }),

        descricao_aluno: JSON.stringify({
            caracteristicas: values.descricao_caracteristicas || "",
            diagnostico: values.descricao_diagnostico || ""
        }),

        objetivos_educacionais: JSON.stringify({
            metas_aprendizagem: values.objetivos_metas_aprendizagem || [""],
            aspectos_sociais: values.objetivos_aspectos_sociais || [""]
        }),

        plano_acao: JSON.stringify({
            estrategias_pedagogicas: values.plano_estrategias_pedagogicas || "",
            materiais_recursos: values.plano_materiais_recursos || "",
            atividades_complementares: values.plano_atividades_complementares || [""]
        }),

        periodo_duracao: JSON.stringify({
            data_inicio: values.periodo_data_inicio ? values.periodo_data_inicio.format("YYYY-MM-DD") : null,
            data_termino: values.periodo_data_termino ? values.periodo_data_termino.format("YYYY-MM-DD") : null,
            data_revisao: values.periodo_data_revisao ? values.periodo_data_revisao.format("YYYY-MM-DD") : null
        }),

        resultados: JSON.stringify({
            indicadores_aprendizagem: values.resultados_indicadores || [""],
            avaliacao_progresso: values.resultados_avaliacao_progresso || ""
        }),

        observacoes_complementares: JSON.stringify({
            informacoes_adicionais: values.obs_informacoes_adicionais || "",
            sugestoes_ajustes: values.obs_sugestoes_ajustes || ""
        })
    });

    const adicionarPlano = values => {
        setIsLoading(true);

        axios({
            method: "post",
            url: "/api/plano-atendimento/adicionar-plano-atendimento",
            data: montarPayload(values)
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "PAEE criado com sucesso.");
                atualizarListagem();
                handleClose();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao criar o PAEE.");
            })
            .finally(() => setIsLoading(false));
    };

    const alterarPlano = values => {
        setIsLoading(true);

        axios({
            method: "put",
            url: "/api/plano-atendimento/alterar-plano-atendimento",
            params: { id },
            data: { ...montarPayload(values) }
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "PAEE alterado com sucesso.");
                atualizarListagem();
                handleClose();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao alterar o PAEE.");
            })
            .finally(() => setIsLoading(false));
    };

    const carregarDadosAlunoEnsinoEspecial = () => {
        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-informacoes-ensino-especial",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { aluno, turma } = response.data;

                setRegisto(prevState => ({
                    ...prevState,
                    apresentacao: {
                        ...prevState.apresentacao,
                        ano_letivo: turma?.edicao || "",
                        aluno: aluno?.nome || "",
                        data_nascimento: aluno?.dataNascimento ? moment(aluno?.dataNascimento) : null,
                        serie_turma: turma?.nome || ""
                    }
                }));
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao carregar dados.");
            });
    };

    const handleClose = () => {
        onClose();
        limparCampos();
    };

    const afterVisibleChange = aberto => {
        if (!aberto && !id) limparCampos();
    };

    const limparCampos = () => {
        resetFields();
        setRegisto(estadoInicial);
    };

    useEffect(() => {
        if (visible && id) carregarDetalhe(id);
        if (visible && !id) {
            limparCampos();
            carregarDadosAlunoEnsinoEspecial();
        }
    }, [id, visible]);

    return (
        <Drawer
            className="drawer-adicionar-evento drawer-add-cursos"
            width={720}
            onClose={handleClose}
            visible={visible}
            style={{ overflow: "auto", height: "calc(100% - 108px)", paddingBottom: "108px" }}
            maskClosable={false}
            afterVisibleChange={afterVisibleChange}
        >
            <div className="bloco-info">
                <Form className="form-categorias" layout="horizontal" onSubmit={handleSubmit}>
                    <SectionCard title="Apresentação">
                        <Form.Item label="Ano letivo">
                            {getFieldDecorator("apresentacao_ano_letivo", {
                                initialValue: registo.apresentacao.ano_letivo
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Aluno(a)">
                            {getFieldDecorator("apresentacao_aluno", {
                                initialValue: registo.apresentacao.aluno
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Data de nascimento" style={{ flex: 1, minWidth: 180 }}>
                            {getFieldDecorator("apresentacao_data_nascimento", {
                                initialValue: registo.apresentacao.data_nascimento
                            })(<DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />)}
                        </Form.Item>

                        <Form.Item label="Série / Turma" style={{ flex: 1, minWidth: 180 }}>
                            {getFieldDecorator("apresentacao_serie_turma", {
                                initialValue: registo.apresentacao.serie_turma
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Professor(a) SRM">
                            {getFieldDecorator("apresentacao_professor_srm", {
                                initialValue: registo.apresentacao.professor_srm
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Pedagogo(a) / Coordenador(a)">
                            {getFieldDecorator("apresentacao_pedagogo_coordenador", {
                                initialValue: registo.apresentacao.pedagogo_coordenador
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Responsáveis legais">
                            {getFieldDecorator("apresentacao_responsaveis_legais", {
                                initialValue: registo.apresentacao.responsaveis_legais
                            })(<Input />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="1. Descrição do Aluno">
                        <Form.Item label="Características cognitivas, socioemocionais e de aprendizagem">
                            {getFieldDecorator("descricao_caracteristicas", {
                                initialValue: registo.descricao_aluno.caracteristicas
                            })(<TextArea rows={4} />)}
                        </Form.Item>

                        <Form.Item label="Diagnóstico ou necessidades específicas (deficiência, TEA, altas habilidades, etc.)">
                            {getFieldDecorator("descricao_diagnostico", {
                                initialValue: registo.descricao_aluno.diagnostico
                            })(<TextArea rows={4} />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="2. Objetivos Educacionais">
                        <div className="bloco-fases-escolares">
                            <h3 className="titulo-separador" style={{ marginBottom: "20px" }}>
                                Metas de aprendizagem e desenvolvimento
                                <button
                                    className="botao-principal"
                                    type="button"
                                    onClick={() => adicionarItemLista("objetivos_metas_aprendizagem")}
                                >
                                    <Icon type="plus" />
                                </button>
                            </h3>
                            <Form.Item style={{ marginBottom: 20 }}>
                                {getFieldDecorator("objetivos_metas_aprendizagem", {
                                    initialValue: registo.objetivos_educacionais.metas_aprendizagem
                                })(<ListaDinamica placeholder="Descreva uma meta..." />)}
                            </Form.Item>

                            <h3 className="titulo-separador" style={{ marginBottom: "20px" }}>
                                Aspectos sociais e emocionais a serem desenvolvidos
                                <button
                                    className="botao-principal"
                                    type="button"
                                    onClick={() => adicionarItemLista("objetivos_aspectos_sociais")}
                                >
                                    <Icon type="plus" />
                                </button>
                            </h3>
                            <Form.Item style={{ marginBottom: 20 }}>
                                {getFieldDecorator("objetivos_aspectos_sociais", {
                                    initialValue: registo.objetivos_educacionais.aspectos_sociais
                                })(<ListaDinamica placeholder="Descreva um aspecto..." />)}
                            </Form.Item>
                        </div>
                    </SectionCard>

                    <SectionCard title="3. Plano de Ação / Atividades">
                        <div className="bloco-fases-escolares">
                            <Form.Item label="Estratégias pedagógicas e métodos de ensino">
                                {getFieldDecorator("plano_estrategias_pedagogicas", {
                                    initialValue: registo.plano_acao.estrategias_pedagogicas
                                })(<TextArea rows={4} />)}
                            </Form.Item>

                            <Form.Item label="Materiais e recursos adaptados utilizados">
                                {getFieldDecorator("plano_materiais_recursos", {
                                    initialValue: registo.plano_acao.materiais_recursos
                                })(<TextArea rows={4} />)}
                            </Form.Item>

                            <h3 className="titulo-separador" style={{ marginBottom: "20px" }}>
                                Atividades complementares ou adaptadas
                                <button
                                    className="botao-principal"
                                    type="button"
                                    onClick={() => adicionarItemLista("plano_atividades_complementares")}
                                >
                                    <Icon type="plus" />
                                </button>
                            </h3>
                            <Form.Item style={{ marginBottom: 20 }}>
                                {getFieldDecorator("plano_atividades_complementares", {
                                    initialValue: registo.plano_acao.atividades_complementares
                                })(<ListaDinamica placeholder="Descreva uma atividade..." />)}
                            </Form.Item>
                        </div>
                    </SectionCard>

                    <SectionCard title="4. Período de Duração">
                        <Form.Item label="Início" style={{ flex: 1, minWidth: 180 }}>
                            {getFieldDecorator("periodo_data_inicio", {
                                initialValue: registo.periodo_duracao.data_inicio,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />)}
                        </Form.Item>

                        <Form.Item label="Término" style={{ flex: 1, minWidth: 180 }}>
                            {getFieldDecorator("periodo_data_termino", {
                                initialValue: registo.periodo_duracao.data_termino,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />)}
                        </Form.Item>

                        <Form.Item label="Revisão prevista" style={{ flex: 1, minWidth: 180 }}>
                            {getFieldDecorator("periodo_data_revisao", {
                                initialValue: registo.periodo_duracao.data_revisao
                            })(<DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="5. Resultados Esperados e Obtidos">
                        <div className="bloco-fases-escolares">
                            <h3 className="titulo-separador" style={{ marginBottom: "20px" }}>
                                Indicadores de aprendizagem e desenvolvimento
                                <button
                                    className="botao-principal"
                                    type="button"
                                    onClick={() => adicionarItemLista("resultados_indicadores")}
                                >
                                    <Icon type="plus" />
                                </button>
                            </h3>
                            <Form.Item style={{ marginBottom: 20 }}>
                                {getFieldDecorator("resultados_indicadores", {
                                    initialValue: registo.resultados.indicadores_aprendizagem
                                })(<ListaDinamica placeholder="Descreva um indicador..." />)}
                            </Form.Item>

                            <Form.Item label="Avaliação contínua do progresso do estudante">
                                {getFieldDecorator("resultados_avaliacao_progresso", {
                                    initialValue: registo.resultados.avaliacao_progresso
                                })(<TextArea rows={4} />)}
                            </Form.Item>
                        </div>
                    </SectionCard>

                    <SectionCard title="6. Observações Complementares">
                        <Form.Item label="Informações adicionais relevantes">
                            {getFieldDecorator("obs_informacoes_adicionais", {
                                initialValue: registo.observacoes_complementares.informacoes_adicionais
                            })(<TextArea rows={4} />)}
                        </Form.Item>

                        <Form.Item label="Sugestões de ajustes ou adaptações futuras">
                            {getFieldDecorator("obs_sugestoes_ajustes", {
                                initialValue: registo.observacoes_complementares.sugestoes_ajustes
                            })(<TextArea rows={4} />)}
                        </Form.Item>
                    </SectionCard>

                    <div className="ant-drawer-footer">
                        <button
                            className="botao-secundario"
                            type="button"
                            onClick={handleClose}
                            style={{ marginRight: 20, display: "inline-block" }}
                        >
                            Cancelar
                        </button>

                        <button className="botao-principal" disabled={isLoading}>
                            {isLoading ? <Icon type="loading" /> : null}
                            Salvar
                        </button>
                    </div>
                </Form>
            </div>
        </Drawer>
    );
};

export default Form.create({ name: "form-drawer-adicionar-paee" })(DrawerPlanoPAEE);
